// P2b tanda 7 (PARTE A) — sugerencias para "Productos relacionados". SOLO
// sugiere: nada se guarda sin que el dueño lo elija. Criterio SIN nombrar
// tipos ni palabras de la tienda: comparte la MISMA categoría hoja (+2) o
// comparte el PADRE con hoja distinta (+1) — eso captura "superior ↔ inferior"
// y "rubor ↔ brocha" por estructura del árbol, no por vocabulario. Colección y
// marca entran como señal cuando P2-tax las llene (hoy las taxonomías están
// vacías — documentado, no un olvido).
// Nota: los productos del listado traen categorías por NOMBRE (mapProduct);
// se resuelven contra el catálogo de categorías por nombre exacto.

export function sugerirRelacionados({ categoryIds = [], productoId = null, elegidos = [] }, productos = [], categorias = []) {
  const porId = new Map((categorias || []).map((c) => [c.id, c]));
  const porNombre = new Map((categorias || []).map((c) => [c.name, c]));
  const misHojas = new Set();
  const misPadres = new Set();
  for (const id of categoryIds || []) {
    const c = porId.get(id);
    if (!c) continue;
    if (c.parent !== 0) { misHojas.add(c.id); misPadres.add(c.parent); }
    else misPadres.add(c.id);
  }
  const excluidos = new Set([productoId, ...(elegidos || [])].filter((x) => x != null).map(Number));
  const puntuados = [];
  for (const p of productos || []) {
    if (excluidos.has(Number(p.id)) || p.status !== 'publish') continue;
    let score = 0;
    for (const nombre of p.categories || []) {
      const c = porNombre.get(nombre);
      if (!c) continue;
      if (misHojas.has(c.id)) score = Math.max(score, 2);
      else if (c.parent !== 0 && misPadres.has(c.parent) && !misHojas.has(c.id)) score = Math.max(score, 1);
    }
    if (score > 0) puntuados.push({ p, score });
  }
  // score desc; a igual score conserva el orden del catálogo (estable)
  return puntuados.sort((a, b) => b.score - a.score).slice(0, 6).map((x) => x.p);
}
